import GameSettings from '@nsftx/games-sdk-js/src/utility/GameSettings';

export default {
  config: null,
  userUuid: null,
  currentBetType: {
    label: null,
    name: null,
    type: null,
    system: null,
    value: null,
    outcome: null,
  },
  checkTicketTimeoutId: null,
  currentSpecialBet: null,
  deliveryPlatform: null,
  gameState: null,
  GameSettings: new GameSettings('keno'),
  isNoDraw: false,
  isNoDrawAuto: false,
  isAllIn: false,
  isGameInfoOpen: false,
  isSettingsOpen: false,
  isStatisticsLoading: false,
  isResultsLoading: false,
  isPayinInProcess: false,
  isBetslipOpen: false,
  isTicketHistoryOpen: false,
  isCancelMessageOpen: false,
  jackpotState: null,
  cancelMessage: null,
  lastSystemSelection: {
    bet: null,
    selection: null,
  },
  layout: null,
  numbers: {
    min: 1,
    max: 81,
  },
  nextRoundDate: null,
  numbersFormat: '0,0.00',
  normalBets: ['Spot', 'System', 'No Draw', 'All In', 'No Bet'],
  nextGenConfig: null,
  paytable: null,
  quickpickNumbersItem: null,
  quickpickSystemsItem: { value: null, label: '' },
  results: null,
  suggestedSystems: null,
  odds: null,
  selectedNumbers: [],
  statistics: null,
  terminalUserData: null,
  terminalTicketsHistory: null,
  terminalTicketDetails: null,
  visualizationState: null,
  ticketToRebet: null,
  activeComponent: null,
  bettingDisabled: false,
  showFreeBetModal: false,
  showFreeBetExpiredModal: false,
  isVisualizationLoaded: false,
  drawnBalls: [],
  nextgenStandaloneIntegration: false,
  usePackageTranslations: true,
};
